import { createFeatureSelector, createSelector } from '@ngrx/store';
import { adapter } from './app-notice.reducer';
import { SharedState } from '..';
import { selectRouteParams } from '@frontdoor/app/state/router.selectors';

const selectors = adapter.getSelectors();
const sharedState = createFeatureSelector<SharedState>('shared-lib');
const appNoticesState = createSelector(
  sharedState,
  (state) => state.appNotices
);
export const selectAll = createSelector(appNoticesState, (state) =>
  selectors.selectAll(state)
);
export const selectAppNotice = createSelector(
  selectAll,
  selectRouteParams,
  (appNotices, params) => {
    return params && appNotices.find((notice) => notice.id == params.noticeId);
  }
);
export const selectActiveNotice = createSelector(
  appNoticesState,
  (state) => state.activeAppNotice
);
export const selectConflictCheck = createSelector(
  appNoticesState,
  (state) => state.conflictingNotice
);
